import React, { Component } from 'react'
import { questions } from './frequently_asked_questions.json'

export class FrequentlyAskedQuestions extends Component {
  render () {
    return <div>
      <h3 className='header'>FAQ</h3>
      {questions.map(({question, answer}) =>
        <div key={question}>
          <div className='question'>{question}</div>
          <div className='answer'>{answer}</div>
        </div>
      )}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/pages/frequently_asked_questions.js